import administrativeSettings from "./administrativeSettings";
import finalcialSettings from "./financialSettings";
import attendanceSettings from "./attendanceSettings";
import accessSettings from "./accessSettings";
import profileSettings from "./profileSettings";
import clientSettings from "./clientSettings";
import protocolSettings from "./protocolSettings";
import ordemServicoSettings from "./ordemServicoSettings";
import eventSettings from "./eventSettings";

export default [
  ...administrativeSettings,
  ...finalcialSettings,
  ...attendanceSettings,
  ...accessSettings,
  ...clientSettings,
  ...protocolSettings,
  ...ordemServicoSettings,
  ...profileSettings,
  ...eventSettings,
];
